<template>
    <div id="Activities">
        <h1 class="h1 center">淨灘活動查詢</h1>
        <ActivityMobile v-if="isMobile"></ActivityMobile>
        <ActivityPc v-else></ActivityPc>
    </div>
</template>
<script>
export default {
    name: 'Activities',
}
</script>
<script setup>
import { computed } from 'vue'
import { ActivityPc, ActivityMobile } from '@/components/ch'
import '@/style/element'
const isMobile = computed(() => window.innerWidth < 768)
</script>
<style lang="scss" scoped></style>
